export default __webpack_public_path__ + "static/media/grey-pin.e81eb76d.svg";